import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './globals.css';
import { API_BASE } from './lib/rpc';
import { initClientTelemetry } from './lib/telemetry';

// Initialize global window exception and unhandled rejection telemetry
initClientTelemetry('crm');

// Monkey patch global fetch to automatically inject CRM tenant headers
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let url = '';
  if (typeof resource === 'string') {
    url = resource;
  } else if (resource instanceof Request) {
    url = resource.url;
  } else if (resource instanceof URL) {
    url = resource.toString();
  }

  if (url.startsWith(API_BASE) || url.startsWith('/') || url.includes('dark.tel/api')) {
    let crmSlug = null;
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] === 'services' && parts[1] === 'crm' && parts[2]) {
      crmSlug = parts[2];
    } else if (parts[0] && parts[0] !== 'login') {
      crmSlug = parts[0];
    }

    let crmPw = crmSlug ? localStorage.getItem(`crm-pw-${crmSlug}`) : null;
    if (!crmPw && crmSlug) {
      crmPw = sessionStorage.getItem(`crm-cdr-pw-${crmSlug}`) || sessionStorage.getItem(`crm-vm-pw-${crmSlug}`);
    }

    if (crmSlug && crmPw) {
      config = config || {};
      const headers = new Headers(config.headers || {});
      
      if (resource instanceof Request) {
        resource.headers.forEach((value, key) => {
          if (!headers.has(key)) headers.set(key, value);
        });
      }
      
      headers.set('x-crm-slug', crmSlug);
      headers.set('x-crm-password', crmPw);
      config.headers = headers;
      
      if (resource instanceof Request) {
        return originalFetch(url, config);
      }
      return originalFetch(resource, config);
    }
  }
  return originalFetch(...args);
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
